module.exports = __webpack_public_path__ + "img/image16.5d64a78a.png";